/**
 * TanStack Query hooks for `fallback-traffic-rules`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fallbackTrafficRulesQueryKeys,
	type CreateFallbackTrafficRulesBody,
	type ListFallbackTrafficRulesResponse,
	type FallbackTrafficRulesRow,
} from "./api";

export function useFallbackTrafficRulesList(): UseQueryResult<ListFallbackTrafficRulesResponse, Error> {
	return useQuery({
		queryKey: fallbackTrafficRulesQueryKeys.list(),
		queryFn: list,
	});
}

export function useFallbackTrafficRulesCreate(): UseMutationResult<FallbackTrafficRulesRow, Error, CreateFallbackTrafficRulesBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fallbackTrafficRulesQueryKeys.all });
		},
	});
}

export function useFallbackTrafficRulesDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fallbackTrafficRulesQueryKeys.all });
		},
	});
}
